/**
 * @generated SignedSource<<3988ad3da7c9b5f6abf2f3718a010e31>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4ForgeMenuItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4AppMenuItem">;
  readonly " $fragmentType": "Nav4ForgeMenuItem";
};
export type Nav4ForgeMenuItem$key = {
  readonly " $data"?: Nav4ForgeMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ForgeMenuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4ForgeMenuItem",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Nav4AppMenuItem"
    }
  ],
  "type": "JiraAppNavigationItem"
};

(node as any).hash = "e6f8d3ee567e6cd74addae3ad5622034";

export default node;
